// Setup YOTPO
	console.log("setup Yotpo");
	const APP_KEY_QA = 'KHiZYtXTMITuH8nzBTye6fID0psLRF7Uhirf3QKp';
	const APP_KEY_PROD = 'Euw8a3S7ftWrtOjbEfxJPICTD7RaUIb4kTGzTCmb';
	const YOTPO_REVIEW_URL = `https://api.yotpo.com/v1/widget`;
	const CREATE_QUESTION_URL = `https://api.yotpo.com/questions/send_confirmation_mail`;
	const APP_KEY = window.Shopify.shop.includes('bragg-dev.myshopify.com')
		? APP_KEY_PROD
		: APP_KEY_QA;
	let page = 1;
	let sort = 'votes_up';
	let sort_direction = 'desc';

	function fetchReviews(e) {
		var sort_clicked = false;
		if (e) {
			e.preventDefault();
			if ($(this).attr('data-sort')) {
				sort = $(this).attr('data-sort');
				sort_direction = $(this).attr('data-order');
				page = 1;
				sort_clicked = true;
				$(".selected").text($(this).text());
			}
		}
		fetch(
			`${YOTPO_REVIEW_URL}/${APP_KEY}/products/${product.id}/reviews.json?page=${page}&sort=${sort}&direction=${sort_direction}`,
			{
				method: 'GET',
			}
		)
			.then(function (response) {
				if (!response.ok) return;

				response.json().then(function (res) {
					const { pagination } = res.response;
					page = pagination.page + 1;
					if (
						pagination.page * pagination.per_page >=
						pagination.total
					) {
						$('#rating .load-more').hide();
					}

					if (sort_clicked) {
						$('.reviews-container .tab-card').remove();
					}
					initReviewData(res.response);
				});
				// const res = await response.json();
				// const {pagination} = res.response;
				// page = pagination.page + 1;
				// if (pagination.page * pagination.per_page >= pagination.total) {
				//     $("#rating .load-more").hide();
				// }
				// initReviewData(res.response);
			})
			.catch((err) => console.error(err));

		function initReviewData(data) {
			// Append reviews
			console.log();
			if (data.reviews.length > 0) {
				$('.custom-yotpo-sorting').show();
			}
			
			data.reviews.forEach((item) => {
				const reviewEl = $(`
                <div class="tab-card">
                    <div class="tab-card__inner">
                        <div class="d-xs-flex align-items-center justify-content-between tab-card__user">
                            <p class="tab-card__user-name">${item.user.display_name}</p>
                            <div class="rating tab-card__user-rating" title="${item.score}">
                                <div class="rating__back"></div>
                            </div>
                        </div>
                        <h3 class="subtitle--2 tab-card__subtitle" data-itemId=${item.id}>${item.title}</h3>
                        <p class="d-xs-block d-md-inline-block tab-card__text">${item.content}</p>
                        <div class="custom-vote vote yotpo">
                        	<span class="up-vote yotpo-icon yotpo-icon-thumbs-up">${item.votes_up}</span>
                        	<span class="down-vote yotpo-icon yotpo-icon-thumbs-down">${item.votes_down}</span>
                        </div>
                    </div>
                </div>
            `);
				for (let i = 1; i <= item.score; i++) {
					reviewEl
						.find('.rating__back')
						.append('<i class="icon-star"></i>');
				}
				$('.reviews-container').append(reviewEl);
				reviewEl.find(".custom-vote .up-vote")
					.on('click', function() {
						var __this = $(this);
						var iId = __this.closest(".tab-card__inner").find("h3").attr("data-itemId");
						var currentLikes = __this.text();
						currentLikes = parseInt(currentLikes);
						console.log(iId);
						
					$.ajax({
					  url: `https://api.yotpo.com/reviews/${iId}/vote/up`,
					  type: "POST",
					  dataType: 'json',
					  success: function(res) {
					  	console.log(res);
							__this.text(currentLikes+1);
						},
					  error: function(err) {
					  	console.log(err);
					  } 	
					});
				});

				reviewEl.find(".custom-vote .down-vote")
					.on('click', function() {
						var __this = $(this);
						var iId = __this.closest(".tab-card__inner").find("h3").attr("data-itemId");
						var currentLikes = __this.text();
						currentLikes = parseInt(currentLikes);
						console.log(iId);
						
					$.ajax({
					  url: `https://api.yotpo.com/reviews/${iId}/vote/down`,
					  type: "POST",
					  dataType: 'json',
					  success: function(res) {
					  	console.log(res);
							__this.text(currentLikes+1);
						},
					  error: function(err) {
					  	console.log(err);
					  } 	
					});
				});	
				
			});
			// Append total review
			const container = $('.rating__star');
			const topContainer = $('.rating');
			const rating_widths = [0,  8.25, 17.75, 27.25, 36.75, 46.25, 55.75, 65.25, 74.75, 84.25, 100];
			if (!data.bottomline.total_review) {
				container.hide();
			} else {
				container
					.find('.rating__text')
					.text(
						`Based on ${data.bottomline.total_review} Review${
							data.bottomline.total_review > 1 ? 's' : ''
						}`
					);
				container
					.find('.rating-wrapper')
					.css('width', rating_widths[Math.round(data.bottomline.average_score * 2.0)] + '%');

				topContainer.show();
				topContainer
					.find('.rating-wrapper')
					.css('width', rating_widths[Math.round(data.bottomline.average_score * 2.0)] + '%');
				topContainer
					.find('span')
					.text(`(${data.bottomline.total_review})`);
			}
		}
	}
	var pageFAQ = 1;
	function fetchFAQ() {
		fetch(
			`https://api.yotpo.com/products/${APP_KEY}/${product.id}/questions?page=${pageFAQ}`,
			{
				method: 'GET',
			}
		)
			.then(function (response) {
				if (!response.ok) return;
				response.json().then(function (res) {
					initFAQData(res.response);
				});
				// const res = await response.json();
				// initFAQData(res.response);
			})
			.catch((err) => console.error(err));
		// initFAQData(require('./test.json').response)
		function initFAQData(data) {
			var dataPage = parseInt(data.page);
			if ( dataPage * data.per_page >= data.total_questions ) {
				console.log('calling');
				$('.review-faq-form__loadmore').hide();
			}
			// Append FAQ
			data.questions.forEach((item) => {
				const answer = item.sorted_public_answers[0];
				const faqEl = $(`
                    <div class="tab-card tab-card--faq">
                        <div class="tab-card__inner">
                            <h6 class=" tab-card__subtitle">${item.content}</h6>
                            <p class="d-xs-block d-md-inline-block tab-card__text" style="white-space: pre-line;">${answer.content}</p>
                            <div class="d-md-grid grid-auto tab-card__footer">
                                <p>Was this question helpful to you?</p>
                                <div class="d-xs-flex question">
                                    <a class="question__cta" data-id="${answer.id}" data-type="up" href="#">YES <sup>${answer.votes_up}</sup></a>
                                    <a class="question__cta" data-id="${answer.id}" data-type="down" href="#">NO <sup>${answer.votes_down}</sup></a>
                                </div>
                            </div>
                        </div>
                    </div>
                `);
				$('.faq-container').append(faqEl);
			});
		}
	}

	if (window.product) {
		fetchReviews();
		fetchFAQ();

		$('#rating .load-more').on('click', fetchReviews);
		$('#rating .sorting .list-category').on('click', fetchReviews);
		
		$('#review-thank-you-close').on('click', function () {
			$('#review-thank-you').hide();
			$('#review-form').show();
		});

		$('#faq-thank-you-close').on('click', function () {
			$('#faq-thank-you').hide();
			$('#faq-form').show();
		});

		const item = document.getElementById('rating');
		let observer = new IntersectionObserver(
			([entry]) => {
				if (entry.intersectionRatio > 0) {
					console.log(item);
					$('.tab__content-item:first-of-type').show();
					observer.unobserve(entry.target);
				}
			},
			{
				root: null,
				rootMargin: '0px',
				threshold: 0.5,
			}
		);
		observer.observe(item);
	}

	//slide section
	$(document).on('click', '.scrollTo', (e) => {
		e.preventDefault();
		let to = $(e.currentTarget).attr('data-scroll'),
			getHeaderHeight = $('.header__inner').outerHeight();
		$('html, body').animate(
			{
				scrollTop: $(`#${to}`).offset().top - getHeaderHeight + 1,
			},
			500
		);
	});